<template>
    <span>
        <!-- 已评价 -->
        <span class="rateContainer"
            v-for="(item, index) in autoArray(userScore)"
            :key="index"
            @click="() => score(index + 1)"
        >
            <svg aria-hidden="true" slot="icon">
                <use xlink:href="#icon-fillStar"></use>
            </svg>
        </span>
        <!-- 未评价 -->
        <span class="rateContainer"
            v-for="(item, index) in autoArray(5 - userScore)"
            :key="5 - index"
            @click="() => score(userScore + index + 1)"
        >
            <svg aria-hidden="true" slot="icon">
                <use xlink:href="#icon-emtpyStar"></use>
            </svg>
        </span>
    </span>
</template>

<script>

export default {
  props: ['userScore', 'score'],
  name: 'FeedBackRate',
  methods: {
    autoArray: (length) => Array.from({ length }).map((s, i) => i),
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.rateContainer {
    position: relative;
    top: 5px;
    padding-right: 4px;
}
.rateContainer svg {
    text-align: left;
    width: .2rem;
    height: .2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/feedBackElement/FeedBackRate.vue